import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // This instantly jumps the scroll to the top
    window.scrollTo(0, 0);
  }, [pathname]); // Fires every time the URL changes

  return null; // This component doesn't render anything visible
}
